export default "__VITE_ASSET__zkLC3b72__"